/* eslint-disable react/jsx-props-no-spreading */
import {
  spectrumCells,
  spectrumRenderers,
} from "@apollo/jsonforms-react-spectrum-renderers";
// import { JsonForms } from "@jsonforms/react";
import * as React from "react";
// import { imsActions } from "./components/IMS";
import { JsonForms } from "@jsonforms/react";
import { useSelector } from "react-redux";
import { FormContext } from "./context/FormsContext";
// import { ImsAuthContext } from "./context/IMSAuthContext";
import ActionCardRenderer, {
  actionCardRendererTester,
} from "./renderers/ActionCardRenderer";
import BreadCrumbsRenderer, {
  breadCrumbsRendererTester,
} from "./renderers/BreadCrumbsRenderer";
import ButtonGroupRenderer, {
  buttonGroupRendererRendererTester,
} from "./renderers/ButtonGroupRenderer";
import ContextValueRenderer, {
  contextValueRendererTester,
} from "./renderers/ContextValueRenderer";
import DynamicSectionRenderer, {
  dynamicSectionRendererTester,
} from "./renderers/DynamicSectionRenderer";
import HeadingRenderer, {
  headingRendererTester,
} from "./renderers/HeadingRenderer";
import HyperLinkRenderer, {
  hyperLinkButtonRendererTester,
} from "./renderers/HyperLinkRenderer";
import ModalButtonRenderer, {
  modalButtonRendererTester,
} from "./renderers/ModalButtonRenderer";
import ModalCancelRenderer, {
  modalCancelRendererTester,
} from "./renderers/ModalCancelRenderer";
import SubmitButtonRenderer, {
  submitButtonRendererTester,
} from "./renderers/SubmitButtonRenderer";
import TextRenderer, { textRendererTester } from "./renderers/TextRenderer";
import WizardRenderer, {
  wizardRendererTester,
} from "./renderers/wizard/WizardFormRenderer";

import { FormProps, GNavProps, LifecycleHooks } from "./types/Pages";
import { DYNAMIC_FORMS } from "./utils/constants";

import * as konsole from "./utils/konsole";
import Loader from "./components/Loader/Loader";
import AdvancedComboboxRenderer, {
  AdvancedComboboxRendererTester,
} from "./renderers/AdvancedComboboxRenderer";
import ButtonRenderer, {
  buttonRendererTester,
} from "./renderers/ButtonRenderer";
import FileUploaderRenderer, {
  FileUploaderRendererTester,
} from "./renderers/FileUploader";
import GNavFooterRenderer, {
  gNavFooterRendererTester,
} from "./renderers/GNavFooterRenderer";
import GNavHeaderRenderer, {
  gNavHeaderRendererTester,
} from "./renderers/GNavHeaderRenderer";
import IconRenderer, { IconRenderTester } from "./renderers/IconRenderer";
import IframeRenderer, { IframeTester } from "./renderers/IframeRenderer";
import ImageRenderer, { ImageTester } from "./renderers/ImageRenderer";
import LeftMenuRenderer, {
  leftMenuRendererTester,
} from "./renderers/LeftMenuRenderer";
import PreformattedContentRenderer, {
  PreformattedContentRendererTester,
} from "./renderers/PreformattedContentRenderer";

import ProgressBar, {
  progressBarRendererTester,
} from "./renderers/ProgressBarRenderer";
import RepeaterRenderer, {
  repeaterRendererTester,
} from "./renderers/RepeaterRenderer";
import SearchRenderer, {
  searchRendererTester,
} from "./renderers/SearchRenderer";
import StatusLightRenderer, {
  statusLightRendererTester,
} from "./renderers/StatusLightRenderer";
import TooltipRenderer, { TooltipTester } from "./renderers/TooltipRenderer";

import SpectrumRichTextRenderer, {
  spectrumRichTextRendererTester,
} from "./renderers/SpectrumRichTextRenderer";
import ReusableComponentRenderer, {
  ReusableComponentRendererTester,
} from "./renderers/ReusableComponentRenderer";
import FormattedNumberRenderer, {
  FormattedNumberRendererTester,
} from "./renderers/FormattedNumberRenderer";
import WizardProgressRenderer, {
  wizardProgressRendererRendererTester,
} from "./renderers/wizard/WizardProgressRenderer";
import MultiSelectRenderer, {
  MultiSelectRendererTester,
} from "./renderers/MultiSelectRenderer";

import { replaceJSONWithTranslations } from "./utils/commonUtils";
import SpanRenderer, { spanRendererTester } from "./renderers/SpanRenderer";
import ToggleButtonRenderer, {
  toggleButtonRendererTester,
} from "./renderers/ToggleButtonRenderer";
import ListRenderer, { ListRendererTester } from "./renderers/ListRenderer";
import AccordionRenderer, {
  accordionRendererTester,
} from "./renderers/AccordionRenderer";
import CompositeCheckbox, {
  compositeCheckboxRendererTester,
} from "./renderers/CompositeCheckboxRenderer";
import DivRenderer, {
  DivRendererTester,
} from "./renderers/DivRenderer";

// const AdvancedWrapper = React.lazy(() => import("./AdvancedWrapper"));

declare const window: any;

export const renderers: any = [
  ...spectrumRenderers,
  // register custom renderers
  {
    renderer: SubmitButtonRenderer,
    tester: submitButtonRendererTester,
  },
  {
    renderer: ModalButtonRenderer,
    tester: modalButtonRendererTester,
  },
  {
    renderer: HyperLinkRenderer,
    tester: hyperLinkButtonRendererTester,
  },
  { renderer: DynamicSectionRenderer, tester: dynamicSectionRendererTester },
  { renderer: TextRenderer, tester: textRendererTester },
  { renderer: ContextValueRenderer, tester: contextValueRendererTester },
  { renderer: BreadCrumbsRenderer, tester: breadCrumbsRendererTester },
  { renderer: ButtonGroupRenderer, tester: buttonGroupRendererRendererTester },
  { renderer: ModalCancelRenderer, tester: modalCancelRendererTester },
  { renderer: HeadingRenderer, tester: headingRendererTester },
  { renderer: GNavHeaderRenderer, tester: gNavHeaderRendererTester },
  { renderer: GNavFooterRenderer, tester: gNavFooterRendererTester },
  { renderer: WizardRenderer, tester: wizardRendererTester },
  { renderer: ButtonRenderer, tester: buttonRendererTester },
  { renderer: SearchRenderer, tester: searchRendererTester },
  { renderer: StatusLightRenderer, tester: statusLightRendererTester },
  { renderer: ActionCardRenderer, tester: actionCardRendererTester },
  { renderer: RepeaterRenderer, tester: repeaterRendererTester },
  { renderer: IconRenderer, tester: IconRenderTester },
  { renderer: IframeRenderer, tester: IframeTester },
  { renderer: ImageRenderer, tester: ImageTester },
  { renderer: TooltipRenderer, tester: TooltipTester },
  {
    renderer: AdvancedComboboxRenderer,
    tester: AdvancedComboboxRendererTester,
  },
  { renderer: LeftMenuRenderer, tester: leftMenuRendererTester },
  {
    renderer: PreformattedContentRenderer,
    tester: PreformattedContentRendererTester,
  },
  { renderer: FileUploaderRenderer, tester: FileUploaderRendererTester },
  { renderer: ProgressBar, tester: progressBarRendererTester },
  {
    renderer: SpectrumRichTextRenderer,
    tester: spectrumRichTextRendererTester,
  },
  {
    renderer: ReusableComponentRenderer,
    tester: ReusableComponentRendererTester,
  },
  { renderer: FormattedNumberRenderer, tester: FormattedNumberRendererTester },
  {
    renderer: WizardProgressRenderer,
    tester: wizardProgressRendererRendererTester,
  },
  {
    renderer: MultiSelectRenderer,
    tester: MultiSelectRendererTester,
  },
  {
    renderer: SpanRenderer,
    tester: spanRendererTester,
  },
  {
    renderer: ToggleButtonRenderer,
    tester: toggleButtonRendererTester,
  },
  {
    renderer: ListRenderer,
    tester: ListRendererTester,
  },
  {
    renderer: AccordionRenderer,
    tester: accordionRendererTester,
  },
  {
    renderer: CompositeCheckbox,
    tester: compositeCheckboxRendererTester,
  },
  {
    renderer: DivRenderer,
    tester: DivRendererTester,
  },
];

/**
 * Load Feds library
 */
const loadFeds = (fedsConfig: GNavProps) => {
  window.fedsConfig = fedsConfig.fedsConfig;

  if (
    window.adobeIMS?.isSignedInUser() &&
    fedsConfig.loggedInExperience &&
    window.fedsConfig?.content
  ) {
    window.fedsConfig.content.experience = fedsConfig.loggedInExperience;
  }
  const fedsLib = document.createElement("script");
  fedsLib.src = fedsConfig.jslib;
  document.body.appendChild(fedsLib);
};

function JSONForm({
  schema,
  uischema,
  data: initialData,
  config,
  onChange,
  renderers: externalRenderers = [],
  authenticated = false,
}: // includeAdvancedRenderers = false,
  FormProps) {
  const [data, setData] = React.useState<any>(initialData);
  const [contextValue] = React.useContext<any>(FormContext);
  const reduxState = useSelector((state: any) => state?.reduxState);
  const { locale, defaultLocale } = reduxState;
  // Translate only if the values have changed
  const updatedUiSchema = React.useMemo(
    () =>
      replaceJSONWithTranslations(
        uischema,
        config?.translations,
        locale,
        defaultLocale
      ),
    [uischema, config?.translations, locale, defaultLocale]
  );

  // Translate only if the values have changed
  const updatedschema = React.useMemo(
    () =>
      replaceJSONWithTranslations(
        schema,
        config?.translations,
        locale,
        defaultLocale
      ),
    [schema, config?.translations, locale, defaultLocale]
  );

  const lifecycleHooks = config?.lifecycleHooks as LifecycleHooks;

  const updateFeds = () => {
    konsole.log(`${DYNAMIC_FORMS}: GNav Loaded`);
    if (lifecycleHooks?.onGNavLoad) {
      config.lifecycleHooks.onGNavLoad();
    }
  };

  React.useEffect(() => {
    konsole.log(`${DYNAMIC_FORMS}: Page loaded`);
    if (lifecycleHooks?.onPageLoad) {
      config.lifecycleHooks.onPageLoad();
    }

    // Load GNav
    if (config?.fedsConfig) {
      window.addEventListener(
        "adobeIMS:profileReady",
        loadFeds(config.fedsConfig)
      );

      window.addEventListener("feds.events.experience.loaded", updateFeds);
    }
    konsole.log(`${DYNAMIC_FORMS}: IMS Ready`);
    if (lifecycleHooks?.onIMSReady) {
      config.lifecycleHooks.onIMSReady();
    }

    return () => {
      if (config?.fedsConfig) {
        window.removeEventListener(
          "adobeIMS:profileReady",
          loadFeds(config.fedsConfig)
        );
      }
    };
  }, []);

  // If authenticated page and user is not signed in
  if (authenticated && !window.adobeIMS?.isSignedInUser()) {
    window.adobeIMS.signIn();
    return <Loader fullScreen />;
  }

  const jsonFormProps = {
    schema: updatedschema,
    uischema: updatedUiSchema,
    data,
    renderers: [...renderers, ...externalRenderers],
    cells: spectrumCells,
    onChange: (props: any) => {
      setData(props.data);
      if (onChange) {
        onChange(props);
      }
    },
    ...contextValue,
    config: {
      // Pass the context in config so that it can be referred in jsonforms-react-spectrum-renderers
      ...contextValue?.config,
      ...config,
      pageContext: reduxState,
    },
  };

  return <JsonForms {...jsonFormProps} />;
}

export default JSONForm;
